// One family each for body and headings that covers Greek and Latin (and &, digits, punctuation)
// with every weight, so mixed «Καλογεράκης Δημήτρης & Βάσω» / «Εταιρεία Demo ΑΕ» text never
// falls back to a second font. Subsets load on demand via unicode-range.
import "@fontsource-variable/manrope/wght.css";
import "@fontsource-variable/literata/opsz.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
